import { render, staticRenderFns } from "./mediaLibrary.vue?vue&type=template&id=4b8ab3ce&"
import script from "./mediaLibrary.vue?vue&type=script&lang=js&"
export * from "./mediaLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports